import NotificacoesInterceptor from '@/Apis/Notificacoes/Services/NotificacoesInterceptor'
import FactoryResponse from '@/factories/FactoryResponse'
import { WebPushSubscriptionPayload } from '@/types/interfaces/PushNotification'

const factory = new FactoryResponse()
const api = new NotificacoesInterceptor()

export default {
  async postSubscription(payload: WebPushSubscriptionPayload) {
    const request = await api.post('v1/webpush/subscriptions', payload)
    return factory.build<void>(request)
  },
}
